import { StyleSheet, TextStyle } from 'react-native';
import theme from '../../../common/theme';
import { ThemeColors } from '../../../common/theme-colors';

export const getStyles = (colors: ThemeColors) => {
  const textStyle: TextStyle = {
    fontSize: 20,
    lineHeight: 28,
    color: colors.text,
    fontFamily: theme.fonts.semibold,
    fontVariant: ['tabular-nums'],
  };

  const textStyleMinor: TextStyle = {
    fontSize: 16,
    lineHeight: 22,
    color: colors.textLight,
    fontFamily: theme.fonts.medium,
    fontVariant: ['tabular-nums'],
  };

  return StyleSheet.create({
    container: {
      rowGap: 8,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      columnGap: 16,
    },
    label: {
      ...textStyle,
      flex: 1,
    },
    value: {
      ...textStyle,
      textAlign: 'right',
    },
    labelMinor: {
      ...textStyleMinor,
      flex: 1,
    },
    valueMinor: {
      ...textStyleMinor,
      textAlign: 'right',
    },
    note: {
      ...textStyleMinor,
      color: colors.focus,
    },
    savings: {
      ...textStyleMinor,
      color: colors.neutral,
    },
    comboItem: {
      paddingLeft: 20,
      rowGap: 8,
    },
  });
};
